import {
  ActionBody,
  Columnz,
  DataTablez,
  RenderHeader,
  StatusBody,
  TimeBody,
  useGetParams,
} from "@/components/DataTable";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { showToast } from "@/redux/features/toast";
import { listToast } from "@/utils";
import { updateSheet, updateSheetDetail } from "../../list_sheet/api";
import { Button } from "@/uiCore";
import {
  useCountListFormFB,
  useCountListPageFB,
  useListFormFB,
  useListPageFB,
} from "../util";
import { updateListPageFB } from "../api";
import { useNavigate, useParams } from "react-router-dom";

const ListFormFacebook = () => {
  const initParams = useGetParams();
  const [paramsPaginator, setParamsPaginator] = useState(initParams);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const list = useListFormFB({ page_id: id, ...paramsPaginator });
  const total = useCountListFormFB({ page_id: id, ...paramsPaginator });
  const dispatch = useDispatch();
  const header = RenderHeader({
    title: "Danh sách page Facebook",
    // exports: {
    //   route: "/list_sheet/export",
    //   action: () => exportRegisterNews(paramsPaginator),
    //   totalRecords: totalRecords,
    //   file: "list_sheet.xlsx",
    // },
  });
  const handleUpdateList = async () => {
    setLoading(true);
    await updateListPageFB();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    dispatch(
      showToast({
        ...listToast[0],
        detail: `Cập nhật dữ liệu Page - Form Facebook thành công!`,
      })
    );
    if (paramsPaginator && setParamsPaginator) {
      setParamsPaginator((pre) => {
        return { ...pre, render: !pre.render };
      });
    }
  };
  return (
    <div className="card">
      <Button loading={loading} onClick={handleUpdateList}>
        Cập nhật page - form FB
      </Button>
      <DataTablez
        value={list}
        header={header}
        title="danh sách page facebook"
        totalRecords={total}
        paramsPaginator={paramsPaginator}
        setParamsPaginator={setParamsPaginator}
      >
        <Columnz field="id_form" header="ID Form" />
        <Columnz field="name" header="Tên Page" />
        <Columnz field="cb_title" header="Dự án" />
        <Columnz
          body={(e) => TimeBody(e?.created_at)}
          bodyStyle={{ textAlign: "center" }}
          header="Ngày tạo"
        />
        <Columnz
          body={(e) => TimeBody(e?.updated_at)}
          bodyStyle={{ textAlign: "center" }}
          header="Cập nhật gần nhất"
        />
        <Columnz
          body={(e) => (
            <div className="flex flex-row">
              <Button
                onClick={() => navigate("/list_form_fb")}
                type="button"
                icon="pi pi-eye"
                rounded
                outlined
                className={" mx-auto flex"}
                severity={"info"}
              />
            </div>
          )}
          header="Danh sách form"
        />
        {/* <Columnz
          header="Trạng thái"
          body={(e) =>
            StatusBody(e, {
              route: "/list_page/update",
              action: updateSheet,
            })
          }
          bodyStyle={{ textAlign: "center" }}
        /> */}
      </DataTablez>
      <div className="w-full justify-content-end flex px-3 pt-2">
        <Button
          type="button"
          onClick={() => navigate("/list_page_fb")}
          label="Trở về"
          className="ml-2"
          severity="secondary"
          size="small"
          outlined
        />
      </div>
    </div>
  );
};
export default ListFormFacebook;
